<template>
    <div>
        <section class="activities-hero-section search-hero primary-background">
            <div class="hero-overlay"></div>
            <div class="container d-flex h-100 align-items-center">
                <div class="search-box__container mx-auto">
                    <form @submit.stop.prevent="submitSearch">
                        <div class="search-input-group mb-3 input-group border border-3 rounded-pill bg-white shadow p-1 p-sm-2">
                            <button v-if="selected.keyword.length > 0" v-on:click="clearKeyword" class="input-group-text search-input-group__icon-clear bg-white border-0 py-0"><i class="bi bi-x text-danger lh-1 fs-1"></i></button>
                            <span v-else class="input-group-text search-input-group__icon-search bg-white rounded-pill border-0"><i class="bi bi-search fs-4"></i></span>
                            <input type="text" name="keyword" class="form-control form-control-lg border-0" 
                                :value="selected.keyword"
                                @input="selected.keyword = $event.target.value"
                                v-on:keyup="filterProducts" 
                                :placeholder="$t('messages.search')">
                            <!-- <button class="btn btn-lg btn-primary rounded-pill px-sm-3 ms-1" type="submit">{{ $t('messages.search') }}</button> -->
                        </div>
                    </form>
                    <div class="search-box__content text-center">
                        <h1 class="d-none">{{ $t('messages.search') }}</h1>
                        <p v-if="selected.keyword != ''" class="mb-0 text-white">{{ $t('messages.Search-results-for') }} "{{selected.keyword}}"</p>
                        <p v-else class="mb-0 text-white">{{ $t('messages.search') }}</p>
                        <p class="lead fs-5 fw-600 text-color-secondary">{{ products_total }} {{ $t('messages.activitiesavailable') }}</p>
                    </div>
                </div>
            </div>
        </section>
        <!-- MOBILE FILTERS -->
        <section class="mobile-filters secondary-background shadow mb-3 d-block d-sm-none px-2">
            <ul class="nav">
                <li class="nav-item">
                    <a class="nav-link" href="#mobileFilterModal" data-bs-toggle="modal" data-bs-target="#mobileFilterModal">
                        <svg xmlns="http://www.w3.org/2000/svg" width="28" height="28" fill="currentColor" class="bi bi-filter" viewBox="0 0 16 16">
                        <path d="M6 10.5a.5.5 0 0 1 .5-.5h3a.5.5 0 0 1 0 1h-3a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h7a.5.5 0 0 1 0 1h-7a.5.5 0 0 1-.5-.5zm-2-3a.5.5 0 0 1 .5-.5h11a.5.5 0 0 1 0 1h-11a.5.5 0 0 1-.5-.5z"/>
                        </svg>
                        <span class="text-uppercase fw-600">{{ $t('messages.Filter') }}</span>
                    </a>
                </li>
                <li class="ms-auto nav-item my-auto">
                    <select class="form-select" v-model="selected.sortby" @change="filterProducts" style="width:180px;">
                        <option value="recommended">{{ $t('messages.Recommended') }}</option>
                        <option value="latest">{{ $t('messages.Latest') }}</option>
                        <option value="price-lowtohigh">{{ $t('messages.PriceLowToHigh') }}</option>
                        <option value="price-hightolow">{{ $t('messages.PriceHighToLow') }}</option>
                    </select>
                </li>
            </ul>
            <div class="modal fade" id="mobileFilterModal" tabindex="-1" aria-labelledby="mobileFilterModalLabel" aria-hidden="true">
            <div class="modal-dialog modal-fullscreen-sm-down">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title" id="mobileFilterModalLabel">{{ $t('messages.Filter') }}</h5>
                        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
                    </div>
                    <div class="modal-body">
                        <div class="widget mb-3">
                            <h5 class="widget-title fs-6">{{ $t('messages.Categories') }}</h5>
                            <ul class="widget-list list-unstyled">
                                <li class="form-check" v-for="category in categories" :key="category.id">
                                    <input class="form-check-input" type="checkbox" :value="category.slug" :id="category.slug" v-model="selected.category" @change="filterProducts">
                                    <label class="form-check-label" :for="category.slug">{{ category.name[lang] }}</label>
                                </li>
                            </ul>
                        </div>
                        <hr />
                        <div class="widget mb-3">
                            <h5 class="widget-title fs-6">{{ $t('messages.Interest') }}</h5>
                            <ul class="widget-list list-unstyled">
                                <li class="form-check" v-for="type in types" :key="type.id">
                                    <input class="form-check-input" type="checkbox" :value="type.slug" :id="type.slug" v-model="selected.type" @change="filterProducts">
                                    <label class="form-check-label" :for="type.slug">{{ type.name[lang] }}</label>
                                </li>
                            </ul>
                        </div>
                        <hr />
                        <div class="widget">
                            <h5 class="widget-title fs-6">{{ $t('messages.price') }}</h5>
                            <div class="row">
                                <div class="col">
                                    <input class="form-control" v-on:keyup="filterProducts" v-model="selected.price_min" :placeholder="$t('messages.PriceMin')+'.'">
                                </div>
                                <div class="col">
                                    <input class="form-control" v-on:keyup="filterProducts" v-model="selected.price_max" :placeholder="$t('messages.PriceMax')+'.'">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="modal-footer">
                        <button v-if="selected.type.length > 0 || selected.category.length > 0 || !!selected.price_max" v-on:click="resetFilter" class="btn btn-danger me-auto">{{ $t('messages.ResetFilter') }}</button>
                        <button type="button" class="btn btn-primary" data-bs-dismiss="modal">{{ $t('messages.Show') }} {{ products_total }} {{ $t('messages.results') }}</button>
                    </div>
                </div>
            </div>
            </div>
        </section>
        <!-- /MOBILE FILTERS -->
        <section class="container-md filters-section py-lg-5 pt-lg-3" id="filterResults">
            <!-- FILTER STARTS -->
            <div class="filters-section__container d-flex gap-3 mt-3 mb-5 d-none d-sm-flex">
                <div class="filters-section__types-menu dropdown">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                        {{ $t('messages.Categories') }}
                    </button>
                    <button v-if="selected.type.length > 0" v-on:click="resetTypeFilter" class="position-absolute top-0 start-100 translate-middle badge px-1 btn btn-danger">
                        <i class="bi bi-x-lg"></i>
                    </button>
                    <div class="dropdown-menu shadow border px-3 py-2">
                        <div v-for="type in types" :key="type.id" class="form-check my-2">
                            <input class="form-check-input" type="checkbox" :value="type.slug" :id="type.slug+'_'+type.id" v-model="selected.type" @change="filterProducts">
                            <label class="form-check-label" :for="type.slug+'_'+type.id">{{ type.name[lang] }}</label>
                        </div>
                    </div>
                </div> 
                <!-- /Types -->
                <div class="filters-section__categories-menu dropdown">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                        {{ $t('messages.Interest') }}
                    </button>
                    <button v-if="selected.category.length > 0" v-on:click="resetCategoryFilter" class="position-absolute top-0 start-100 translate-middle badge px-1 btn btn-danger">
                        <i class="bi bi-x-lg"></i>
                    </button>
                    <div class="dropdown-menu shadow border px-3 py-3">
                        <div v-for="category in categories" :key="category.id" class="form-check my-2">
                            <input class="form-check-input" type="checkbox" :value="category.slug" v-model="selected.category" @change="filterProducts" :id="category.slug+'_'+category.id" >
                            <label class="form-check-label" :for="category.slug+'_'+category.id">{{ category.name[lang] }}</label>
                        </div>
                    </div>
                </div> 
                <!-- /Categories -->
                <div class="filters-section__price-range dropdown">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                        {{ $t('messages.price') }}
                    </button>
                    <button v-if="!!selected.price_max" v-on:click="resetPriceFilter" class="position-absolute top-0 start-100 translate-middle badge px-1 btn btn-danger">
                        <i class="bi bi-x-lg"></i>
                    </button>
                    <div class="dropdown-menu shadow border p-3">
                        <div class="row">
                            <div class="col">
                                <input class="form-control" v-on:keyup="filterProducts" v-model="selected.price_min" :placeholder="$t('messages.PriceMin')+'.'">
                            </div>
                            <div class="col">
                                <input class="form-control" v-on:keyup="filterProducts" v-model="selected.price_max" :placeholder="$t('messages.PriceMax')+'.'">
                            </div>
                        </div>
                    </div>
                </div> 
                <!-- /Price -->
                <div class="filters-section__sortby dropdown ms-auto">
                    <button type="button" class="btn btn-outline-secondary dropdown-toggle" data-bs-toggle="dropdown" aria-expanded="false" data-bs-auto-close="outside">
                        {{ $t('messages.SortBy') }}
                    </button>
                    <div class="dropdown-menu px-3 py-2 dropdown-menu-end">
                        <div class="form-check ps-0 my-2">
                            <input class="form-check-input d-none" type="radio" value="recommended" v-model="selected.sortby" v-on:click="filterProducts" id="recommended">
                            <label class="form-check-label" for="recommended">
                                {{ $t('messages.Recommended') }}
                            </label>
                        </div>
                        <div class="form-check ps-0 my-2">
                            <input class="form-check-input d-none" type="radio" value="latest" v-model="selected.sortby" v-on:click="filterProducts" id="latest">
                            <label class="form-check-label" for="latest">
                                {{ $t('messages.Latest') }}
                            </label>
                        </div>
                        <div class="form-check ps-0 my-2">
                            <input class="form-check-input d-none" type="radio" value="price-lowtohigh" v-model="selected.sortby" v-on:click="filterProducts" id="price_lowhigh">
                            <label class="form-check-label" for="price_lowhigh">
                                {{ $t('messages.PriceLowToHigh') }}
                            </label>
                        </div>
                        <div class="form-check ps-0 my-1">
                            <input class="form-check-input d-none" type="radio" value="price-hightolow" v-model="selected.sortby" v-on:click="filterProducts" id="price_hightolow">
                            <label class="form-check-label" for="price_hightolow">
                                {{ $t('messages.PriceHighToLow') }}
                            </label>
                        </div>
                        <!-- <div class="form-check">
                            <input class="form-check-input" type="radio" value="oldest" v-model="selected.sortby" v-on:click="filterProducts" id="oldest">
                            <label class="form-check-label" for="oldest">
                                {{ $t('messages.Oldest') }}
                            </label>
                        </div> -->
                    </div>
                </div> 
                <!-- /Sortby -->
            </div>
            <!-- /FILTER ENDS -->
            <div class="row g-2 g-lg-3"> 
                <div v-for="product in products" :key="product.id" class="col-20">
                    <div class="card shadow-sm product-card mb-4">
                        <img :src="cdn_url+'products/'+product.image+'?auto=format,enhance,compress&fit=crop&crop=faces&h=200&w=260'" class="card-img-top" alt="" />
                        <div class="card-body card-body p-2 p-lg-3 pb-0 pb-lg-0">
                            <span v-if="product.type_name" class="text-uppercase small fw-bold text-secondary">{{ product.type_name[lang] }}</span>
                            <a :href="'/'+lang+'/t/'+product.type+'/'+product.id+'/'+product.slug" class="product-title stretched-link">{{ product.title[lang] }}</a>
                        </div>
                        <div class="card-bottom d-md-flex justify-content-between px-2 pb-2 px-lg-3 pb-lg-3">
                            <div class="product-price mt-auto">
                                <div class="text-muted small">{{ $t('messages.startingfrom') }}</div>
                                <span v-if="product.sale_price > 0" class="fw-bold text-color-secondary fs-5">{{ product.sale_price }} &euro;</span>
                                <span v-else class="fw-bold fs-5">{{ product.price }} &euro;</span>
                                <span v-if="product.sale_price > 0" class="fs-5 price-old">{{ product.price }} &euro;</span>
                            </div>
                            <div class="product-rating rating-stars d-none d-md-block mt-auto pb-1">
                                <review-ratings v-if="website_review != 0" :rating="product.rating_average"></review-ratings>
                                <div v-if="product.rating_average > 0" class="small"><strong>{{ product.rating_average }}</strong> ({{ product.reviews_count }} {{ $t('messages.reviews') }})</div>
                                <div v-else class="small">{{ $t('messages.Noreviewsyet') }}</div>
                            </div>
                        </div>
                    </div>
                </div>
                <infinite-loading :identifier="infiniteId" @infinite="loadProducts">
                    <template #spinner>
                        <div class="text-center">
                            {{ $t('messages.loading') }}...
                            <svg xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" style="margin:auto;background:transparent;display:block;" width="5rem" height="5rem" viewBox="0 0 100 100" preserveAspectRatio="xMidYMid">
                                <circle cx="50" cy="50" r="30" stroke="#303297" stroke-width="10" fill="none"></circle>
                                <circle cx="50" cy="50" r="30" stroke="#ff4d50" stroke-width="8" stroke-linecap="round" fill="none">
                                <animateTransform attributeName="transform" type="rotate" repeatCount="indefinite" dur="1s" values="0 50 50;180 50 50;720 50 50" keyTimes="0;0.5;1"></animateTransform>
                                <animate attributeName="stroke-dasharray" repeatCount="indefinite" dur="1s" values="18.84955592153876 169.64600329384882;94.2477796076938 94.24777960769377;18.84955592153876 169.64600329384882" keyTimes="0;0.5;1"></animate>
                                </circle>
                            </svg>
                        </div>
                    </template>
                    <template #complete>
                        <div>
                            <!-- No more results -->
                        </div>
                    </template>
                </infinite-loading>
            </div>
        </section>
        
    </div>
</template>

<script>
export default {
    props: {
        lang: String,
        website_id: String,
        website_review: String,
        //keyword: String,
        //type: String,
        bgimg: String,
        route_search: String
    },

    data() {
        return {
            isLoading: true,
            page: 1,
            types: [],
            categories: [],
            products: [],
            products_total: 0,
            quickSearchResults: [],
            selected: {
                keyword: '',
                type: [],
                category: [],
                sortby: 'recommended',
            },
            infiniteId: +new Date(),
            cdn_url: process.env.MIX_CDN_URL
        }
    },

    methods: {
        filterParams() {
            let params = '?page='+this.page;
            params += '&sortby='+this.selected.sortby;
            params += this.selected.keyword != '' ? '&keyword='+this.selected.keyword: '';
            params += this.selected.category != '' ? '&category='+this.selected.category : '';
            params += this.selected.type != '' ? '&type='+this.selected.type : '';
            params += this.selected.price_min != null ? '&price_min='+this.selected.price_min : '';
            params += this.selected.price_max != null ? '&price_max='+this.selected.price_max : '';

            return params;
        },

        searchQuickAction() {
            this.quickSearchResults = [];
            if (this.keyword == null || (this.keyword != null && this.keyword.length === 0)) {
                this.quickSearchResults = [];
            } else {
                if (this.keyword.length >= 2) {
                    axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/search_quick', {
                        params: {
                            query: this.keyword,
                        },
                    })
                    .then(res => (this.quickSearchResults = res.data))
                    .catch(err => console.log(err));
                }
            }
        },

        loadProducts($state)  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/search'+this.filterParams()).then(({ data }) => {
                this.products_total = data.products.total;
                this.categories = data.categories;
                this.types = data.types;
                    this.isLoading = false;
                if (data.products.data.length) {
                    this.page += 1;
                    this.products.push(...data.products.data);
                    $state.loaded();
                } else {
                    $state.complete();
                }
            });
        },

        filterProducts() {
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;

            //Scroll to top
            // $('html, body').animate({
            //     scrollTop: $("#filterResults").offset().top
            // });
        },

        loadTypes()  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/search')
                .then(response => {
                    this.types = response.data.types;
                    this.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        loadCategories()  {
            axios.get(process.env.MIX_API_URL+'/'+this.website_id+'/search')
                .then(response => {
                    this.categories = response.data.categories;
                    this.isLoading = false;
                })
                .catch(function (error) {
                    console.log(error);
                });
        },

        resetFilter() {
            this.selected.keyword = '';
            this.selected.type = [];
            this.selected.category = [];
            this.selected.price_min = '';
            this.selected.price_max = '';
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
        },

        resetTypeFilter() {
            this.selected.type = [];
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
        },
        resetCategoryFilter() {
            this.selected.category = [];
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
            //this.loadProducts()
        },
        resetPriceFilter() {
            this.selected.price_min = '';
            this.selected.price_max = '';
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
        },

        clearKeyword() {
            this.selected.keyword = '';
            this.quickSearchResults = [];
            this.page = 1;
            this.products = [];
            this.infiniteId += 1;
        }
    }
}
</script>